import React from 'react';
import MilestoneForm from '../../components/Milestones/MilestoneForm';

const MilestoneCreate = () => {
  return <MilestoneForm isEdit={false} />;
};

export default MilestoneCreate;


